export class Cursor {
    constructor(x = 36, y = 36) {
        this.x = x;
        this.y = y;
    }

    getX() {
        return this.x;
    }

    getY() {
        return this.y;
    }

    setX(x) {
        this.x = x;
        return this;
    }

    setY(y) {
        this.y = y;
        return this;
    }

    setPosition(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }

    moveY(delta) {
        this.y += delta;
        return this;
    }

    space(height) {
        return this.moveY(height);
    }
}
